module.exports = __webpack_public_path__ + "assets/0b02feb920b94aba8501c0b8125b0013.png";